import React from 'react';
import Header from '../components/Header';
import Banner from '../components/Banner';
import LabImageViewer from '../components/LabImageViewer';
import MainSection from '../components/MainSection';
import './main.css'
const HomePage: React.FC = () => {
  
  const data ={
    page: 'main'
  };

  return (
    <div id="page-wrapper">      
      {/* <Header menuItems={menuItems} /> */}
      <Banner /> 
      <LabImageViewer/><br/><br/>
      <MainSection page={data.page}/>
    </div>
  );
};

export default HomePage;
